import React from "react";
import PropTypes from "prop-types";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import All from "assets/images/modal_image_all.png";
import Specific from "assets/images/modal_image_specific.png";

const ExperienceModal = ({ buttonName, open, onCancel, bookingType }) => {
    const [t] = useTranslation()
    return (
        <Modal
            title={t("webIntegration.button_label_name")}
            open={open}
            footer={null}
            onCancel={onCancel}
        >
            <img
                src={bookingType === "all" ? All : Specific}
                alt="all"
                style={{ width: "100%" }}
            />
            <p style={{ color: "black" }}>
                {t("webIntegration.button_behavior", {
                    buttonName,
                    description:
                        bookingType === "all"
                            ? t("webIntegration.description_all")
                            : t("webIntegration.description_specific")
                })}
            </p>
        </Modal>
    );
};

ExperienceModal.propTypes = {
    buttonName: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    bookingType: PropTypes.oneOf(["all", "specific"]).isRequired,
};

export default ExperienceModal;
